import { useCallback, useEffect, useRef, useState } from 'react';
import './ResizeHandle.css';

type ResizeHandleProps = {
  onResize: (deltaX: number) => void;
};

export const ResizeHandle = ({ onResize }: ResizeHandleProps) => {
  const [isDragging, setIsDragging] = useState(false);
  const lastXRef = useRef(0);

  const handleMouseDown = useCallback((e: React.MouseEvent) => {
    e.preventDefault();
    setIsDragging(true);
    lastXRef.current = e.clientX;
  }, []);

  useEffect(() => {
    if (!isDragging) return;

    const handleMouseMove = (e: MouseEvent) => {
      const deltaX = e.clientX - lastXRef.current;
      lastXRef.current = e.clientX;
      onResize(deltaX);
    };

    const handleMouseUp = () => {
      setIsDragging(false);
    };

    window.addEventListener('mousemove', handleMouseMove);
    window.addEventListener('mouseup', handleMouseUp);

    return () => {
      window.removeEventListener('mousemove', handleMouseMove);
      window.removeEventListener('mouseup', handleMouseUp);
    };
  }, [isDragging, onResize]);

  return (
    <div
      className={`resize-handle ${isDragging ? 'resize-handle--dragging' : ''}`}
      onMouseDown={handleMouseDown}
    >
      <div className="resize-handle__indicator" />
    </div>
  );
};
